import { mailApiGet, mailApiPost } from "@/lib/api/client";

export type MailNewMailEvent = {
  id: number;
  accountId: number;
  folder: string;
  newCount: number;
  sampleSubject: string;
  sampleFrom: string;
  createdAt: string;
};

type PendingResponse = {
  success: boolean;
  events: MailNewMailEvent[];
};

type AckResponse = {
  success: boolean;
  acked: number;
};

export function fetchPendingMailNotifications(accountId?: number) {
  const qs = accountId != null ? `?accountId=${accountId}` : "";
  return mailApiGet<PendingResponse>(`notifications/pending.php${qs}`);
}

export function ackMailNotifications(ids: number[]) {
  return mailApiPost<AckResponse>("notifications/ack.php", { ids });
}
